// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UiTextarea[data-v-6b0a27de]{border:var(--input-border);min-height:var(--input-height);padding:10px var(--input-padding-x);border-radius:var(--input-radius);width:100%;min-width:0px}.UiTextarea[data-v-6b0a27de]:focus{border-color:var(--input-focus-border-color);box-shadow:var(--input-focus-shadow)}\n", ""]);
// Exports
module.exports = exports;
